module.exports = __webpack_public_path__ + "zyro-icnirp.png?697efabc18751dd984ce7bf65304bfd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newsenviromental/zyro-icnirp.png
// module id = 315
// module chunks = 0